import workspaceQuery from '../../../graphql/queries/company/CompanyUserRoleWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CompanyUserRoleListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CompanyUserRoleQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CompanyUserRoleDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CompanyUserRoleMutation.graphql';
import fragment from '../../../graphql/fragments/company/CompanyUserRoleFragment.graphql';

const CompanyUserRole = {
  type: 'CompanyRole',
  title: 'User Roles',
  formTitle: 'User Role',
  formUrl: '/Company/UserRole/Details/',
  workspaceUrl: '/Company/UserRole/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'USER_ROLES',
};

export default CompanyUserRole;
